import React, { FC, memo } from 'react';
import Main from '@components/Layout/Main';
import FAQs from '@components/FAQs';
import CustomError from '@components/CustomError';
import { useTranslations } from '@hooks/useTranslations';
import routes from '../../constants/routes';
import { ERROR_CODE } from '../../pages/_error';
import { NeedHelpSection } from '@components/NeedHelpSection';

export const InvalidConfiguration: FC = memo(() => {
    const { t } = useTranslations();

    return (
        <Main title={String(ERROR_CODE.NOT_FOUND)}>
            <CustomError
                errorType={String(ERROR_CODE.NOT_FOUND)}
                returnLink={routes.ROOT}
                returnLinkLabel={t('errorPage.returnLink.label')}
                titleDescription={t('errorPage.notFound.description')}
            />
            <NeedHelpSection />
            <FAQs />
        </Main>
    );
});
InvalidConfiguration.displayName = 'InvalidConfiguration';
